import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { createAction } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";

const slice = createSlice({
  name: "mgaCode",
  initialState: {
    isMga: [],
    isMgaModalOpen: false,
    onSuccessMessage: {},
    mgaFailedMessage: null,
    isSingleMgaObj: {},
    isAdding: false,
    isAdded: false,
    isDelete: false,
  },

  reducers: {
    // GET Request
    allMgaCodeReceived: (mgaCode, action) => {
      mgaCode.isMga = action.payload;
    },
    mgaObjectNull: (mgaCode, action) => {
      mgaCode.isSingleMgaObj = {};
    },
    mgaMessageNull: (mgaCode, action) => {
      mgaCode.onSuccessMessage = {};
    },
    createMgaModalOpened: (mgaCode, action) => {
      mgaCode.isMgaModalOpen = true;
      mgaCode.mgaFailedMessage = null;
      mgaCode.isAdded = false;
      mgaCode.onSuccessMessage = {};
    },
    createMgaModalClosed: (mgaCode, action) => {
      mgaCode.isMgaModalOpen = false;
      mgaCode.mgaFailedMessage = null;
    },
    mgaAdding: (mgaCode, action) => {
      mgaCode.isAdding = true;
    },
    mgaAdded: (mgaCode, action) => {
      mgaCode.isAdding = false;
      mgaCode.isAdded = true;
      mgaCode.onSuccessMessage = action.payload;
    },
    updateSingleMgaObject: (mgaCode, action) => {
      mgaCode.isSingleMgaObj = action.payload;
    },
    mgaDeletedSuccess: (mgaCode, action) => {
      mgaCode.isDelete = true;
    },
    mgaStartSuccess: (mgaCode, action) => {
      mgaCode.isDelete = true;
    },
    mgaAddingFailed: (mgaCode, action) => {
      mgaCode.mgaFailedMessage = action.payload;
    },
  },
});

export const {
  allMgaCode,
  createMgaModalOpened,
  createMgaModalClosed,
  allMgaCodeReceived,
  mgaAdding,
  mgaAdded,
  updateSingleMgaObject,
  mgaObjectNull,
  mgaDeletedSuccess,
  mgaStartSuccess,
  mgaMessageNull,
  mgaAddingFailed,
} = slice.actions;

export default slice.reducer;

// action creator

export const getAllMgaList = () =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/ipfs/insurer-code?type=mgaCode",
    method: "get",
    onSuccess: allMgaCodeReceived.type,
  });

export const addNewMgaDetail = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/ipfs/insurer-code",
    method: "post",
    data: data,
    onStart: mgaAdding.type,
    onSuccess: mgaAdded.type,
    onError: mgaAddingFailed.type,
  });

export const getDeleteMga = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/ipfs/insurer-code",
    method: "delete",
    data: data,
    onStart: mgaStartSuccess.type,
    onSuccess: mgaDeletedSuccess.type,
  });
// Selector
export const getMgaListData = createSelector(
  (state) => state.entities.mgaCode,
  (mgaCode) => mgaCode.isMga.data
);

export const getMgaModalOpen = createSelector(
  (state) => state.entities.mgaCode,
  (mgaCode) => mgaCode.isMgaModalOpen
);
export const getSelectedMgaObj = createSelector(
  (state) => state.entities.mgaCode,
  (mgaCode) => mgaCode.isSingleMgaObj
);

export const getMgaSuccess = createSelector(
  (state) => state.entities.mgaCode,
  (mgaCode) => mgaCode.onSuccessMessage
);

export const isDeletingMga = createSelector(
  (state) => state.entities.mgaCode,
  (mgaCode) => mgaCode.isDelete
);
export const isMgaAdded = createSelector(
  (state) => state.entities.mgaCode,
  (mgaCode) => mgaCode.isAdded
);
export const getMgaFailed = createSelector(
  (state) => state.entities.mgaCode,
  (mgaCode) => mgaCode.mgaFailedMessage
);
